if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.getElementById('rebuy-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.handleAddonChange = this.handleAddonChange.bind(this);
        this.quantities = {};

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.unsubscribeAddonChange = subscribe(PUB_SUB_EVENTS.addonChange, this.handleAddonChange);
        
      }

      handleAddonChange(event) {
        const variantId = event.variantId;
        const quantity = parseInt(event.quantity) || 0;
      
        // Save the quantity for each variant
        this.quantities[variantId] = quantity;
      
        // Total all addon quantities
        const totalAddonQty = Object.values(this.quantities).reduce((sum, qty) => sum + qty, 0);
      
        // Get main product quantity (outside the form)
        const mainQtyInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
        
        const mainQty = parseInt(mainQtyInput?.value) || 1;
      
        if (totalAddonQty === 0) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        } else {
          const totalQty = mainQty + totalAddonQty;
          this.submitButtonText.textContent = `Add ${totalQty} Items To Bag`;
        }
      }
      
      

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };
        
        const formData = new FormData(this.form);
        
        const closestWrapper = this.submitButton.closest('.product-form__input');
        const closestQuantityInput = closestWrapper?.querySelector('input[name="quantity"], select[name="quantity"]');
        
        const mainItem = {
          id: parseInt(formData.get('id')),
          quantity: parseInt(closestQuantityInput?.value) || 1
        };
        
        const addonItems = Array.from(document.querySelectorAll('product-addons .select__select'))
          .map(select => {
            if (select.disabled) return null;
            const id = parseInt(select.name);
            const quantity = parseInt(select.value);
            if (!id || quantity < 1) return null;
            return { id, quantity };
          })
          .filter(Boolean);
        
        const items = [mainItem, ...addonItems];
        
        config.body = JSON.stringify({ items });
        
        fetch('/cart/add.js', config)
          .then(res => res.json())
          .then((response) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainItem.id,
              cartData: response
            });
            Rebuy.SmartCart.show();
          })
          .catch(console.error)
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
        
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      toggleAddonSubmitButton() {
        // If form has addon, we must edit the text to say 'Add 2 Items To Bag' for example.
        // When adding to cart, we must add the addon to the cart as well.
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}